import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-edit-loyalty-rewards',
  templateUrl: './edit-loyalty-rewards.component.html',
  styleUrls: ['./edit-loyalty-rewards.component.scss']
})
export class EditLoyaltyRewardsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {


  
  generatePromoForm: FormGroup;
  providers: any;

  constructor(private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    ) {
    
    super();
    
  }

 

  ngOnInit(): void {
    super.ngOnInit();
    this.initiateForm();

  }

  initiateForm = () => {
    this.generatePromoForm = this.fb.group({
      promoCode : '',
      product : '',
      carrier : '',
      country : '',
      amount1 : '',
      amount2 :'',
      fromDate :'',
      toDate :'',
      discount : '',
      discountValue : '',
      redeemLimit :'',
      description : '',
    })
  }

  get f() {
    return this.generatePromoForm.controls;
  }

  onPromoCodeSubmit() {

    //console.log(this.newProductForm);
    if (this.generatePromoForm.valid) {
     
    }

    else {

    }
  }

  

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {
    
    this.generatePromoForm.reset();
    window.location.reload();
  }

}
